import { render, staticRenderFns } from "./DataObjectList.vue?vue&type=template&id=23d27109&scoped=true&"
import script from "./DataObjectList.vue?vue&type=script&lang=js&"
export * from "./DataObjectList.vue?vue&type=script&lang=js&"
import style0 from "./DataObjectList.vue?vue&type=style&index=0&id=23d27109&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d27109",
  null
  
)

export default component.exports